export const publicApis = [
  'login',
  'public/token/validate',
  //   'registration',
  //   'checktokenvalidity',
  //   'forgotpassword',
  //   'completeRegistration',
  //   'resetpassword',
  //   'confirmregistration',
  //   'token/validate',
  //   'user/changepassword',
];

export const mgmtApis = [
  'user/entity',
  'user/company/assignedGstinsDtls',
  'subscription/active',
  'user/changecompany',
  'company/businesshierarchy',
  'user/company/filingbusiness',
];

export const STATUS = {
  INPROGRESS: 'tag-blue',
  SUCCESS: 'tag-green',
  FAILURE: 'tag-red',
};

export interface AccessControlStatus {
  status: string;
}

export const accessControlList: { [key: string]: AccessControlStatus } = {
  '1': { status: 'PENDING SUBMISSION' },
  '2': { status: 'DRAFT' },
  '3': { status: 'PENDING FOR REVIEW' },
  '4': { status: 'REVIEWED' },
  '5': { status: 'SUBMITTED' },
  '6': { status: 'ESIGN SUCCESSFULLY' },
  '7': { status: 'ESIGN UNSUCCESSFUL' },
  '8': { status: 'FILED' },
  '9': { status: 'PENDING FOR RETURN CREATION' },
  '10': { status: 'FAILED' },
  '11': { status: 'IN PROGRESS' },
  '12': { status: 'READY TO FILE' },
};

export const POS_CODE_LIST = [
  { label: 'Jammu & Kashmir', value: '01' },
  { label: 'Himachal Pradesh', value: '02' },
  { label: 'Punjab', value: '03' },
  { label: 'Chandigarh', value: '04' },
  { label: 'Uttarakhand', value: '05' },
  { label: 'Haryana', value: '06' },
  { label: 'Delhi', value: '07' },
  { label: 'Rajasthan', value: '08' },
  { label: 'Uttar Pradesh', value: '09' },
  { label: 'Bihar', value: '10' },
  { label: 'Sikkim', value: '11' },
  { label: 'Arunachal Pradesh', value: '12' },
  { label: 'Nagaland', value: '13' },
  { label: 'Manipur', value: '14' },
  { label: 'Mizoram', value: '15' },
  { label: 'Tripura', value: '16' },
  { label: 'Meghalaya', value: '17' },
  { label: 'Assam', value: '18' },
  { label: 'West Bengal', value: '19' },
  { label: 'Jharkhand', value: '20' },
  { label: 'Odisha', value: '21' },
  { label: 'Chhattisgarh', value: '22' },
  { label: 'Madhya Pradesh', value: '23' },
  { label: 'Gujarat', value: '24' },
  { label: 'Daman & Diu Dadra & Nagar Haveli', value: '26' },
  { label: 'Maharashtra', value: '27' },
  { label: 'Karnataka', value: '29' },
  { label: 'Goa', value: '30' },
  { label: 'Lakshdweep', value: '31' },
  { label: 'Kerala', value: '32' },
  { label: 'Tamil Nadu', value: '33' },
  { label: 'Pondicherry', value: '34' },
  { label: 'Andaman & Nicobar Islands', value: '35' },
  { label: 'Telengana', value: '36' },
  { label: 'Andhra Pradesh', value: '37' },
  { label: 'Ladakh', value: '38' },
  { label: 'Other Country', value: '96' },
  { label: 'Other Territory', value: '97' },
];
